module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1503_-21657d574061132a608e8ead1d973b0b.png";